import { render, staticRenderFns } from "./FormData.vue?vue&type=template&id=46577b00&scoped=true"
import script from "./FormData.vue?vue&type=script&setup=true&lang=ts"
export * from "./FormData.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./FormData.vue?vue&type=style&index=0&id=46577b00&prod&scoped=true&lang=scss"
import style1 from "./FormData.vue?vue&type=style&index=1&id=46577b00&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46577b00",
  null
  
)

export default component.exports